import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class DeligateService {
  public subject = new Subject<any>();
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**API to get employee list */
  getempList(role): Observable<any> {
    const data = {
      'role': role
    };
    return this.httpService.post(`delegation/listemployees`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to add RM to delegate */
  postDelegate(data, url): Observable<any> {
    return this.httpService.post(url, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get delegated RM*/
  getDelegate(role): Observable<any> {
    const data = {
      'empno': role.toString()
    };
    return this.httpService.post(`listDelegation`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to delete delegation*/
  deleteDelegate(id): Observable<any> {
    const data = {
      'delegationID': id
    };
    return this.httpService.post(`deleteDelegation`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to send delegate*/
  sendDelegate(data) {
    this.subject.next(data);
  }

  /**Function to handle error data for requested API*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/deligate/deligate.service.ts